import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * PayerName item interface for ui_metadata storage
 */
export interface PayerNameItem {
  id: string;
  displayLabel: string;
  name: string;
}

/**
 * Transform API response to PayerNameItem format
 */
export const transformPayerName = (apiItem: { id: string; name: string }): PayerNameItem => ({
  id: apiItem.id,
  displayLabel: apiItem.name,
  name: apiItem.name,
});

/**
 * Modal configuration for PayerName selector
 */
export const payerNameModalConfig: GenericSelectorModalConfig<PayerNameItem> = {
  title: 'Select Payer Names',
  searchPlaceholder: 'Search payer names...',
  emptyStateIcon: faFileInvoiceDollar,
  emptyStateMessage: 'No payer names selected',
  noResultsMessage: (searchTerm) => `No payer names found for "${searchTerm}"`,
  colorTheme: 'sky',
  selectionMode: 'multiple',
  showConnectorToggle: true,
  defaultConnector: 'ANY',
  getItemLabel: (item) => item.name,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'payer name',
  itemLabelPlural: 'payer names',
};

/**
 * Node display configuration for PayerName
 */
export const payerNameNodeConfig: GenericNodeComponentConfig<PayerNameItem> = {
  colorTheme: 'sky',
  getItemLabel: (item) => item.name,
  getItemKey: (item) => item.id,
  maxVisibleItems: 2,
  showConnectorLabel: true,
};
